// getRankInLiveStream.js
'use strict';
import createCachedSelector from '../resource/createCachedSelector.js';

import getListData from '../selector/getListData.js';
import {
  RANGE_SESSION,
  liveStreamSessionLeaderboardCategory,
} from '../resource/liveStreamConstants.js';

const defaultRange = RANGE_SESSION;
const defaultCategory = liveStreamSessionLeaderboardCategory.TOTAL;

/**
 * Select rank in live stream by stream id
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} streamId - livestream id.
 * @param {string} sessionId - livestream session id.
 * @param {string} userId - user id.
 * @param {string} [category = 'total'] - category.
 * @return {number} The selected rank in live stream.
 */
const getRankInLiveStream = createCachedSelector(
  (
    state,
    streamId,
    sessionId,
    userId,
    range = defaultRange,
    category = defaultCategory
  ) => {
    const selectPath =
      range === RANGE_SESSION
        ? [
            'liveStream',
            streamId,
            'session',
            sessionId,
            'leaderboard',
            category,
          ]
        : ['liveStream', streamId, 'leaderboard', range];
    const giftLeaderboard = getListData(state, selectPath, 'itemIds');

    return giftLeaderboard || [];
  },
  (state, streamId, sessionId, userId) => userId,
  (giftLeaderboard, userId) => {
    return giftLeaderboard.indexOf(userId) + 1;
  }
)(
  (
    state,
    streamId,
    sessionId,
    userId,
    range = defaultRange,
    category = defaultCategory
  ) =>
    `getRankInLiveStream:${streamId}:${sessionId}:${userId}:${range}:${category}`
);

export default getRankInLiveStream;
